import { Component, ChangeDetectionStrategy, OnInit, Input, ChangeDetectorRef } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Utils from '@shared/core/utils';

import { TilesComponent } from '../../tiles.shared.component';
import { ILoyaltyAppTransactionMenuFlow, ILoyaltyAppTransactionProduct } from '@shared/state';

@Component({
    selector: 'shared-tile-for-transaction-product-item',
    templateUrl: './tile-for-transaction-product-item.shared.component.html',
    styleUrls: ['./tile-for-transaction-product-item.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileForTransactionProductItemComponent extends TilesComponent implements OnInit {
    public isMenuFlow: boolean = false;
    public title: string;
    public total: number;
    public description: string;

    @Input() public bottomPadding: boolean = false;
    @Input() public transactionItem: ILoyaltyAppTransactionProduct & ILoyaltyAppTransactionMenuFlow;

    constructor(
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }

    ngOnInit(): void {
        this.isMenuFlow = !!this.transactionItem?.MenuFlowId;
        this.title = `${this.transactionItem?.Quantity || 1}x
        ${this.transactionItem?.CustomerFriendlyName || this.transactionItem?.POSDisplay || this.transactionItem?.MenuFlowDescription}`;
        this.total = this.transactionItem?.TotalGross;
        this.description = this.isMenuFlow ? Utils.OnlineOrders.generateDescriptionForTransactionMenuFlowActivationItem(this.transactionItem) : '';
    }
}
